import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import AirportTerminal from '../entities/flight/airportTerminal';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface AirportTerminalState extends ListState<AirportTerminal> {
  airportTerminal: AirportTerminal;
  editAirportTerminal: AirportTerminal;
}

class AirportTerminalMutations extends ListMutations<AirportTerminal> {}

class AirportTerminalModule extends ListModule<
  AirportTerminalState,
  any,
  AirportTerminal
> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<AirportTerminal>(),
    loading: false,
    editAirportTerminal: new AirportTerminal(),
    selectAirportTerminal: new AirportTerminal(),
  };
  actions = {
    async selectAirportTerminal(
      context: ActionContext<AirportTerminalState, any>,
      payload: any
    ) {
      context.state.editAirportTerminal = payload.data;
    },

    async saveAirportTerminal(
      context: ActionContext<AirportTerminalState, any>,
      payload: any
    ) {
      let reponse = await Ajax.post(
        '/api/services/app/Flight/SaveAirportTerminal',
        payload.data
      );

      let page = reponse.data.result as PageResult<AirportTerminal>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async updateAirportTerminal(
      context: ActionContext<AirportTerminalState, any>,
      payload: any
    ) {
      let reponse = await Ajax.put(
        '/api/services/app/Flight/UpdateAirportTerminal',
        payload.data
      );

      let page = reponse.data.result as PageResult<AirportTerminal>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async getAirportTerminals(
      context: ActionContext<AirportTerminalState, any>,
      payload: any
    ) {
      // context.state.loading=true;
      let reponse = await Ajax.get(
        '/api/services/app/Flight/GetAirportTerminals',
        payload.data
      );

      // context.state.loading=false;
      let page = reponse.data.result as PageResult<AirportTerminal>;
      context.state.totalCount = page.totalCount;
      context.state.list = page.items;
    },
    async deleteAirportTerminal(
      context: ActionContext<AirportTerminalState, any>,
      payload: any
    ) {

      await Ajax.delete(
        '/api/services/app/Flight/DeleteAirportTerminal?input=' +
          payload.payload
      );
    },
  };
  mutations = {
    setCurrentPage(state: AirportTerminalState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AirportTerminalState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const airportTerminalModule = new AirportTerminalModule();
export default airportTerminalModule;
